import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "src/app/providers/navigation.service";
import { EditBusinessDetailsComponent } from "../new-v2-component/edit-business-details/edit-business-details.component";
import { NewUploadMediaComponent } from "../new-v2-component/new-upload-media/new-upload-media.component";
import { EditServiceComponent } from "../new-v2-component/edit-service/edit-service.component";
import { NewEditLocationComponent } from "../new-v2-component/new-edit-location/new-edit-location.component";
import { NewShowallGalleryComponent } from "../new-v2-component/new-showall-gallery/new-showall-gallery.component";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { UploadBusinessImageComponent } from "src/app/shared/components/upload-business-image/upload-business-image.component";
import { ViewMediaGalleryComponent } from "src/app/shared/components/view-media-gallery/view-media-gallery.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { UploadLogoForBusinessComponent } from "../new-v2-component/upload-logo-for-business/upload-logo-for-business.component";
import { AlertService } from "src/app/providers/alert.service";
import { ImageCropperComponent } from "../new-v2-component/image-cropper/image-cropper.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomainMappingComponent } from "../new-v2-component/domain-mapping/domain-mapping.component";
import { AddBusinessExternalLinksComponent } from "../new-v2-component/add-business-external-links/add-business-external-links.component";

@Component({
  selector: "sm-business-details-owners",
  templateUrl: "./business-details-owners.component.html",
  styleUrls: ["./business-details-owners.component.scss"],
})
export class BusinessDetailsOwnersComponent implements OnInit, OnDestroy {
  businessLogo: any = {
    imageThumbUrl: null,
  };
  _apiSubscription: Subscription;
  _entityDetails: any[] = [];
  entityHashId: any;
  loader: boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private _alertService: AlertService,
    private loaderService: LoaderServiceService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private navservice: NavigationService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.navservice.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT) {
        console.log(resData);
        if (resData.result && resData.result != null) {
          this._entityDetails = [];
          this._entityDetails.push(resData.result[0]);

          // 0 - unmapped
          // 1 - mapped

          this._entityDetails[0].domain_details =
            typeof this._entityDetails[0].domain_details == "string"
              ? JSON.parse(this._entityDetails[0].domain_details)
              : this._entityDetails[0].domain_details;

          this._entityDetails[0].entity_services =
            typeof this._entityDetails[0].entity_services == "string"
              ? JSON.parse(this._entityDetails[0].entity_services)
              : this._entityDetails[0].entity_services;

          this._entityDetails[0].addressInfo =
            typeof this._entityDetails[0].addressInfo == "string"
              ? JSON.parse(this._entityDetails[0].addressInfo)
              : this._entityDetails[0].addressInfo;

          this._entityDetails[0].assetInfo =
            this._entityDetails[0].assetInfo &&
            typeof this._entityDetails[0].assetInfo == "string"
              ? JSON.parse(this._entityDetails[0].assetInfo)
              : this._entityDetails[0].assetInfo;

          // filteration of entity asset
          this.businessLogo = {
            imageThumbUrl: null,
          };
          if (
            this._entityDetails[0].assetInfo &&
            this._entityDetails[0].assetInfo.length > 0
          ) {
            // this._entityDetails[0].assetInfo = this.removeDuplicateImages(this._entityDetails[0].assetInfo)

            const index_of_logo = this._entityDetails[0].assetInfo.findIndex(
              (asset: any) => asset.asset_usage_type == 3,
            );

            if (index_of_logo != -1) {
              this.businessLogo =
                this._entityDetails[0].assetInfo[index_of_logo];
              this._entityDetails[0].assetInfo.splice(index_of_logo, 1);
            }
          }

          localStorage.setItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
            this._entityDetails[0].employee_hash_id,
          );

          localStorage.setItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
            this._entityDetails[0].entPubHash,
          );

          sessionStorage.setItem(
            "shop_service_status",
            this._entityDetails[0].shopServiceStatus,
          );
          sessionStorage.setItem(
            "home_service_status",
            this._entityDetails[0].homeServiceStatus,
          );
          sessionStorage.setItem(
            "virtual_service_status",
            this._entityDetails[0].virtual_service_status,
          );

          this._entityDetails[0].provided_services = [];

          if (resData.result[0].shopServiceStatus != 2) {
            this._entityDetails[0].provided_services.push({
              service_name: "Shop",
            });
          }
          if (resData.result[0].homeServiceStatus != 2) {
            this._entityDetails[0].provided_services.push({
              service_name: "Home",
            });
          }
          if (resData.result[0].virtual_service_status != 2) {
            this._entityDetails[0].provided_services.push({
              service_name: "Virtual",
            });
          }
        }
        this.loaderService.showLoader = false;
        this.loader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_BY_OWNER
      ) {
        if (resData.result) {
          this.loaderService.showLoader = false;
          this.router.navigate(["/dashboard"]);
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SET_MEDIA_AS_DEFAULT
      ) {
        if (resData.result) {
          this.loaderService.showLoader = false;
          this._alertService.onOpenSnackbar(
            "Media set as default successfully.",
          );
          this._apiService.getBasicEntityList();
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_UPLOADED_MEDIA
      ) {
        if (resData.result) {
          // this.loaderservice.showLoader = false
          this._alertService.onOpenSnackbar("Media deleted successfully.");
          this._apiService.getEntityDetails(this.entityHashId);
          this._apiService.getBasicEntityList();
        }
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      this.loader = true;
      this.loaderService.showLoader = true;
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this._apiService.getEntityDetails(this.entityHashId);
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }
  editbusinessdetail() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Alert",
        message:
          "Once you update business info, your business will become De-Activated to be verified by Admin. During this period bookings from People apps and websites will be disabled. Though you can use all the other features without any hassle.",
        okbtn: "Continue edit",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let dialogref = this.dialog.open(EditBusinessDetailsComponent, {
          width: "500px",
          data: {
            entityDetails: this._entityDetails[0],
          },
        });
        dialogref.afterClosed().subscribe((res) => {
          if (res) {
            this.loader = true;
            this.loaderService.showLoader = true;
            this._apiService.getEntityDetails(this.entityHashId);
            this._apiService.getBasicEntityList();
          }
        });
      }
    });
  }

  uploadmediax() {
    this.dialog.open(NewUploadMediaComponent, {
      width: "500px",
    });
  }

  editservice() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Alert",
        message:
          "Once you update business info, your business will become De-Activated to be verified by Admin. During this period bookings from People apps and websites will be disabled. Though you can use all the other features without any hassle.",
        okbtn: "Continue edit",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let dialogref = this.dialog.open(EditServiceComponent, {
          width: "500px",
          data: {
            entityDetails: this._entityDetails[0],
          },
        });
        dialogref.afterClosed().subscribe((res) => {
          if (res) {
            this.loaderService.showLoader = true;

            this._apiService.getEntityDetails(this.entityHashId);
          }
        });
      }
    });
  }
  editlocation() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Alert",
        message:
          "Once you update business info, your business will become De-Activated to be verified by Admin. During this period bookings from People apps and websites will be disabled. Though you can use all the other features without any hassle.",
        okbtn: "Continue edit",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let dialogref = this.dialog.open(NewEditLocationComponent, {
          width: "800px",
          data: {
            data: this._entityDetails[0].addressInfo,
            entityHash: this.entityHashId,
          },
        });
        dialogref.afterClosed().subscribe((res) => {
          if (res) {
            this.loaderService.showLoader = true;

            this._apiService.getEntityDetails(this.entityHashId);
            this._apiService.getBasicEntityList();
          }
        });
      }
    });
  }

  showallphotos() {
    this.dialog.open(NewShowallGalleryComponent, {
      width: "900px",
    });
  }

  viewMedia() {
    if (
      this._entityDetails[0].assetInfo &&
      this._entityDetails[0].assetInfo != null &&
      this._entityDetails[0].assetInfo != "null"
    ) {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "1200px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data:
            typeof this._entityDetails[0].assetInfo == "string"
              ? JSON.parse(this._entityDetails[0].assetInfo)
              : this._entityDetails[0].assetInfo,
          entityHash: this._entityDetails[0].hashId,
          asset_type: this._entityDetails[0].asset_type,
        },
      });
    } else {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "500px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data: [],
        },
      });
    }
  }

  uploadMedia() {
    let dialogref = this.dialog.open(UploadBusinessImageComponent, {
      width: "500px",
      data: {
        title: "Upload Media",
        data: this._entityDetails[0],
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.loaderService.showLoader = true;

        this._apiService.getEntityDetails(this.entityHashId);
      }
    });
  }
  uploadBusinessLogo() {
    let dialogref = this.dialog.open(UploadLogoForBusinessComponent, {
      width: "500px",
      data: {
        title: "Upload Logo",
        data: this._entityDetails[0],
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.loaderService.showLoader = true;

        this._apiService.getEntityDetails(this.entityHashId);
      }
    });
  }
  fileChangeEvent(event: any): void {
    const inputElement = event.target;
    if (event.target.files.length > 0) {
      let sizeinKb = +event.target.files[0].size / 1000;
      if (sizeinKb > 1024) {
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok",
        );
        return;
      } else {
        console.log("File change Event: ", event);
        let file = event;
        console.log(file);
        let dialogref = this.dialog.open(ImageCropperComponent, {
          width: "700px",
          disableClose: true,
          data: {
            title: "Upload Logo",
            data: this._entityDetails[0],
            file: file,
          },
        });
        dialogref.afterClosed().subscribe((res) => {
          if (res) {
            this.loaderService.showLoader = true;

            this._apiService.getEntityDetails(this.entityHashId);
          }
          inputElement.value = "";
        });
      }
    }
  }

  onUploadRegnImage(inputEl: Event) {
    console.log("ele: ", inputEl);
    // const selectedFile = inputEl.target.files[0];
    // console.log(selectedFile)
    // this.uploadService.uploadMedia({
    //   uploadType: CM_CONSTANTS.DOCTOR_UPLOADS,
    //   file: selectedFile
    // });
  }

  deactivateBusiness() {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "600px",
      data: {
        title: "Business delete warning!",
        message:
          "Are you sure you want to delete " +
          this._entityDetails[0].entityName +
          "? Once you delete the business, people will no longer find you via search. Also no operation and data access going to happen further. A deleted business can only be revived with a support request.",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          entityHash: this._entityDetails[0].hashId,
        };

        this.loaderService.showLoader = true;
        this._apiService.deleteEntityByOwner(data);
      }
    });
  }

  setDefaultImage(item: any) {
    let data = {
      entity_hash: this.entityHashId,
      asset_hash: item.hash_id,
    };
    console.log(data);
    this.loaderService.showLoader = true;
    this._apiService.setMediaAsDefault(data);
  }

  deleteImage(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this media?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          entityHash: this.entityHashId,
          assetHash: item.hash_id,
        };
        this.loaderService.showLoader = true;
        this._apiService.deleteUploadedMedia(obj);
      }
    });
  }

  removeDuplicateImages(arr: any) {
    const map = new Map();

    arr.forEach((item: any) => {
      const key = `${item.imgUrl}-${item.imageThumbUrl}`;

      if (!map.has(key)) {
        // If the item doesn't exist in the map, add it
        map.set(key, item);
      } else {
        // If the item already exists, check asset_usage_type and keep the higher one
        const existingItem = map.get(key);
        if (item.asset_usage_type > existingItem.asset_usage_type) {
          map.set(key, item);
        }
      }
    });

    // Convert the map values back to an array
    return Array.from(map.values());
  }

  adddomainmapping() {
    let dref = this.dialog.open(DomainMappingComponent, {
      width: "100%",
      maxWidth: "500px",
      data: {
        domainMappingData: this._entityDetails[0].domain_details,
        entity_hash: this.entityHashId,
      },
    });
    dref.afterClosed().subscribe((data) => {
      if (data) {
        this._apiService.getEntityDetails(this.entityHashId);
      }
    });
  }
  addexternallinks() {
    let dref = this.dialog.open(AddBusinessExternalLinksComponent, {
      width: "100%",
      maxWidth: "500px",
      data: {
        domainMappingData: this._entityDetails[0].domain_details,
        entity_hash: this.entityHashId,
      },
    });
    dref.afterClosed().subscribe((data) => {
      if (data) {
        this._apiService.getEntityDetails(this.entityHashId);
      }
    });
  }
}
